import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { type RepoPaginatedResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginatedResponse'
import {
  SlackUser,
  type SlackUserConstructor,
} from '@webapp/platform/integrations/entities/SlackUser/SlackUser'
import { slackIntegrationQueries } from '@webapp/platform/integrations/query-configs/slackIntegrationQueries'

export const useListSlackUsersModel = (): {
  slackUsers: SlackUser[]
  isLoading: boolean
} => {
  const { data, isLoading } = useQuery<
    RepoPaginatedResponse<SlackUserConstructor>
  >({
    ...slackIntegrationQueries.slackUsers({
      collection: 'non_bots',
      orderBy: 'name',
      limit: 'all',
    }),
  })

  const slackUsers = useMemo(() => {
    return data?.data.map((user) => new SlackUser(user)) ?? []
  }, [data])

  return {
    slackUsers,
    isLoading,
  }
}
